import Category from "./category";
import Store from "./store";
import Product from "./product";

interface Discount {
  id?: number;
  name?: string;
  discountPercentage?: number;
  firstThreshold?: number | null;
  secondDiscountValue?: number | null;
  secondThreshold?: number | null;
  discountType?: string;
  scopeType?: string;
  applyToRetail?: boolean;
  applyToWholesale?: boolean;
  applyToSuperwholesale?: boolean;
  isActive?: boolean;
  companyId?: number;
  categories?: Category[];
  products?: Product[];
  stores?: Store[];
}

export const newDiscount = (): Discount => {
  return {};
};

type DiscountMaps = { [key: string]: string };

const DISCOUNTTYPËS: DiscountMaps = {
  percentage: "Porcentaje",
  fixed_amount: "Descuento de Monto Fijo",
  set_price: "Fijar Precio",
  two_levels: "Descuento de dos Niveles",
  cashback: "Reintegro",
  cashback_only_ticket: "Reintegro solo ticket",
};

export const getDiscountTypeLabel = (key: string) => {
  return DISCOUNTTYPËS[key];
};

/**
 * Explicación de cada tipo, para el tooltip y el texto de ayuda del formulario.
 * Vive acá y no en el JSX para no duplicar el texto entre los dos.
 */
export const DISCOUNT_TYPE_HELP: DiscountMaps = {
  percentage:
    "El monto del descuento es el % que se hará sobre el precio del producto. " +
    "Ej: si introduce 20 se hará un 20% de descuento sobre el precio.",
  fixed_amount:
    "El monto del descuento es un valor en Gs que se descontará al precio del " +
    "producto. Ej: si introduce 5000 se hará un descuento de 5000 Gs sobre el " +
    "precio.",
  set_price:
    "El monto del descuento es un valor en Gs que directamente reemplazará al " +
    "precio del producto. Ej: si introduce 30000, todos los productos " +
    "afectados por el descuento se venderán por 30000 Gs.",
  two_levels:
    "El monto del descuento es un valor en Gs que se descontará al precio del " +
    "producto si se alcanza un valor predeterminado, y luego un descuento " +
    "mayor si se alcanza un segundo valor predeterminado en productos de las " +
    "categorías. Ej: 2500 Gs de descuento en cada unidad si se alcanza un " +
    "total de venta de 5000000 Gs en las categorías, y luego 5000 Gs por " +
    "unidad si se alcanzan 10000000 Gs.",
  cashback:
    "A diferencia de los demás, este NO baja el precio. La venta se emite por " +
    "su monto total y el vendedor le reintegra el monto en efectivo al cliente " +
    "por cada unidad que caiga en la promoción. Ej: si introduce 10000 y el " +
    "cliente lleva 3 unidades, se le reintegran 30000 Gs. Solo aplica a ventas " +
    "100% en efectivo y tiene prioridad sobre los demás descuentos.",
  cashback_only_ticket:
    "Descuenta el monto indicado por unidad, igual que un descuento de monto " +
    "fijo, pero solo si la venta se paga 100% en efectivo, y en el ticket " +
    "impreso figura como \"REINTEGRO\". A diferencia del Reintegro común, " +
    "este SÍ baja el total de la venta: se factura con el descuento aplicado " +
    "y no se le entrega plata en efectivo al cliente.",
};

/** Los tipos en el orden en que se ofrecen en el formulario. */
export const DISCOUNT_TYPES_ORDER = [
  "percentage",
  "fixed_amount",
  "set_price",
  "two_levels",
  "cashback",
  "cashback_only_ticket",
];

const DISCOUNTSCOPETYPËS: DiscountMaps = {
  category: "Categorías",
  product: "Productos",
};

export const getDiscountScopeTypeLabel = (key: string) => {
  return DISCOUNTSCOPETYPËS[key];
};

export interface DiscountLog {
  id?: number;
  companyId?: number;
  name?: string;
  status?: string;
  storesAffected?: string;
  categoriesAffected?: string;
  productsAffected?: string;
  userName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export default Discount;
